import { ChangeEvent, SyntheticEvent, useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useQueryClient } from "react-query";
import { CreateContextPayload } from "../../../api/types/context";
import { useCreateContext } from "../../../api/queries/context/useCreateContext";
import { defaultInvalidateQueryFilters, queryKeys } from "../../../api/query";
import { Panel } from "primereact/panel";
import { useNavigate } from "react-router-dom";

export default function ContextForm() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const createContext = useCreateContext();

  const [name, setName] = useState<string>("");
  const onNameChange = (event: ChangeEvent<HTMLInputElement>): void =>
    setName(event.target.value);

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();

    const payload: CreateContextPayload = {
      name,
    };

    await createContext.mutateAsync(payload);

    queryClient.invalidateQueries(
      queryKeys.journeyTypes(),
      defaultInvalidateQueryFilters,
    );

    navigate("/admin/contexts");
  };

  return (
    <form onSubmit={handleSubmit} className="col-12">
      <Panel header="Context" toggleable={true} className="mb-3">
        <div className="p-fluid">
          <div className="field pt-3">
            <div className="p-float-label">
              <InputText value={name} onChange={onNameChange} />
              <label>Name *</label>
            </div>
          </div>
        </div>
      </Panel>

      <div className="flex gap-1 justify-content-end">
        <Button
          type="submit"
          label="Save"
          className="p-button-main p-button-sm"
          disabled={!name}
        />
      </div>
    </form>
  );
}
